export default function CaseStudy() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Кейс: как программа адаптации спасла компанию от текучести
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Реальная история компании из 120 сотрудников, где внедрение системы онбординга изменило всё.
        </p>

        <div className="bg-gray-50 rounded-2xl p-8 md:p-12 border border-gray-200">
          <div className="grid lg:grid-cols-3 gap-8">
            {/* Проблема */}
            <div className="bg-red-50 rounded-xl p-6 border border-red-200">
              <div className="w-10 h-10 bg-red-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-close-circle-line text-xl text-white"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-4">Проблема</h3>
              <p className="text-gray-700 text-sm leading-relaxed mb-4">
                Компания из сферы услуг со штатом 120 сотрудников столкнулась с кризисом: <strong>40% новичков увольнялись в первые три месяца</strong>. Рекрутинг работал на износ, руководители жаловались на «слабых» кандидатов.
              </p>
              <ul className="space-y-1 text-gray-600 text-sm">
                <li className="flex items-start gap-2"><i className="ri-close-line text-red-500 mt-0.5"></i> Текучка — 40% за первые 3 месяца</li>
                <li className="flex items-start gap-2"><i className="ri-close-line text-red-500 mt-0.5"></i> Нет единого процесса адаптации</li>
                <li className="flex items-start gap-2"><i className="ri-close-line text-red-500 mt-0.5"></i> Руководители перегружены</li>
              </ul>
            </div>

            {/* Что сделали */}
            <div className="bg-teal-50 rounded-xl p-6 border border-teal-200">
              <div className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-settings-3-line text-xl text-white"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-4">Что сделали</h3>
              <ul className="space-y-2 text-gray-700 text-sm">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>Создали программу адаптации для трёх категорий сотрудников</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>Назначили и обучили 12 наставников из числа опытных сотрудников</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>Подготовили чек-листы на каждую неделю адаптации</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>Обучили руководителей работе с новичками</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span>Провели сопровождение системы в течение 3 месяцев</span>
                </li>
              </ul>
            </div>

            {/* Результаты */}
            <div className="bg-green-50 rounded-xl p-6 border border-green-200">
              <div className="w-10 h-10 bg-green-600 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-check-line text-xl text-white"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-4">Результаты</h3>
              <ul className="space-y-2 text-gray-700 text-sm">
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-up-line text-green-600 mt-0.5 flex-shrink-0"></i>
                  <span>Снижение текучести с 40% до 12% за первые 3 месяца</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-up-line text-green-600 mt-0.5 flex-shrink-0"></i>
                  <span>Выход на KPI сократился с 4-5 до 2 месяцев</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-up-line text-green-600 mt-0.5 flex-shrink-0"></i>
                  <span>Рост удовлетворённости сотрудников на 35%</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-arrow-up-line text-green-600 mt-0.5 flex-shrink-0"></i>
                  <span>Экономия на рекрутинге — около 3 млн руб. в год</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}